export default __webpack_public_path__ + "static/tourist-traps-7-useful-tactics-fd9bd3c847a024e718266bd49ab96096.jpg";